module.exports = __webpack_public_path__ + "images/花筑pr长图_04-4.jpg?v=dc12284a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_04-4.jpg
 ** module id = 17
 ** module chunks = 1 2
 **/